import AccountViewSection from "../../view/parts/AccountViewSection";
import AccountVerificationViewSection from "../../view/parts/AccountVerificationViewSection";
import PersonViewSection from "../../view/parts/PersonViewSection";
import { useEffect } from "react";
import { foreignIdThunk } from "../../../../../../store/redux/slice/AppData/foreignId";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { countriesDataThunk } from "../../../../../../store/redux/slice/AppData/countriesData";
import { receiveResultThunk } from "../../../../../../store/redux/slice/AppData/receiveResult";
import RepresentativeViewSection from "../../view/parts/RepresentativeViewSection";
import { nationalUniversitiesDataThunk } from "../../../../../../store/redux/slice/AppData/nationalUniversitiesData";
import ContactAddressViewSection from "../../view/parts/ContactAddressViewSection";
import ResultReceiveViewSection from "../../view/parts/ResultReceiveViewSection";
import ReceiverAddressViewSection from "../../view/parts/ReceiverAddressViewSection";

const UserMainDetailsDisplay = ({ record }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(foreignIdThunk());
    dispatch(countriesDataThunk());
    dispatch(receiveResultThunk());
    dispatch(nationalUniversitiesDataThunk());
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <AccountViewSection record={record} />
      <AccountVerificationViewSection record={record} />
      <PersonViewSection record={record} />
      <RepresentativeViewSection record={record} />
      <ContactAddressViewSection record={record} />
      <ResultReceiveViewSection record={record} />
      <ReceiverAddressViewSection record={record} />
    </>
  );
};

export default UserMainDetailsDisplay;
